import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-16"
}
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex align-center mt-1" }
const _hoisted_5 = { class: "text-caption text-grey-darken-1 mt-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "ml-3" }
const _hoisted_8 = {
  key: 1,
  class: "ml-3"
}
const _hoisted_9 = {
  key: 0,
  class: "deadline-overdue ml-1"
}
const _hoisted_10 = { class: "ml-3" }
const _hoisted_11 = {
  key: 0,
  class: "tp-workflow mt-3"
}
const _hoisted_12 = { class: "tp-workflow__label" }
const _hoisted_13 = {
  key: 0,
  class: "tp-workflow__name"
}
const _hoisted_14 = {
  key: 1,
  class: "tp-workflow__at"
}
const _hoisted_15 = {
  key: 2,
  class: "tp-workflow__at"
}
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "tp-pre" }
const _hoisted_18 = { class: "text-caption" }
const _hoisted_19 = {
  class: "text-caption text-grey-darken-1 mr-2 d-flex align-center",
  style: {"min-width":"150px"}
}
const _hoisted_20 = {
  key: 1,
  class: "text-error"
}
const _hoisted_21 = { class: "text-error" }
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "text-body-2" }
const _hoisted_25 = {
  key: 0,
  class: "text-body-2 mt-3"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 2,
  class: "text-center text-grey py-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_teaching_plan_grid = _resolveComponent("teaching-plan-grid")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_teaching_plan_support_panel = _resolveComponent("teaching-plan-support-panel")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_teaching_plan_transfer_dialog = _resolveComponent("teaching-plan-transfer-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_ctx.detail)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                variant: "text",
                size: "small",
                onClick: _ctx.backToList
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[10] || (_cache[10] = _createTextVNode(" 一覧へ戻る ", -1))
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.planLabel), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.detail.plan.templateName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "レイアウト: " + _toDisplayString(_ctx.detail.plan.templateName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, "第" + _toDisplayString(_ctx.detail.plan.version) + "版", 1),
                  (_ctx.detail.plan.deadlineDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createTextVNode(" 提出期限: " + _toDisplayString(_ctx.formatDate(_ctx.detail.plan.deadlineDate)) + " ", 1),
                        (_ctx.isDeadlineOverdue)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "期限超過"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_10, "作成者: " + _toDisplayString(_ctx.detail.plan.authorName), 1)
                ])
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", {
                class: "status-badge",
                style: _normalizeStyle({
            backgroundColor: _ctx.statusStyles[_ctx.detail.plan.status].background,
            color: _ctx.statusStyles[_ctx.detail.plan.status].color,
          })
              }, _toDisplayString(_ctx.statusStyles[_ctx.detail.plan.status].label), 5)
            ]),
            (_ctx.workflowSteps.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflowSteps, (step, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["tp-workflow__step", `tp-workflow__step--${step.state}`])
                    }, [
                      _createVNode(_component_v_icon, { size: "15" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.workflowStepIcons[step.state]), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(step.label), 1),
                      (step.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(step.name), 1))
                        : _createCommentVNode("", true),
                      (step.at)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatDateTime(step.at)), 1))
                        : (step.state === 'current')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "承認待ち"))
                          : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.detail.plan.status === 'returned' && _ctx.detail.workflow.returnedReason)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 1,
                  type: "error",
                  variant: "tonal",
                  density: "compact",
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, " 差戻しされました（" + _toDisplayString(_ctx.formatDateTime(_ctx.detail.workflow.returnedAt)) + "） ", 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.detail.workflow.returnedReason), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.detail.permissions.canApprove || _ctx.detail.permissions.canReturn)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 2,
                  variant: "tonal",
                  color: "primary",
                  class: "mt-3 pa-3 d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "font-weight-bold" }, "承認をお願いします", -1)),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.approverSubText), 1)
                    ]),
                    _createVNode(_component_v_spacer),
                    (_ctx.detail.permissions.canReturn)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "mr-2",
                          color: "error",
                          variant: "flat",
                          disabled: _ctx.processing,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnDialog = true))
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" 差戻し ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.detail.permissions.canApprove)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          color: "primary",
                          variant: "flat",
                          loading: _ctx.approving,
                          disabled: _ctx.processing,
                          onClick: _ctx.approve
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" 承認する ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (!_ctx.detail.permissions.canEdit)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 3,
                    type: "info",
                    variant: "tonal",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.lockedReason), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
            _createVNode(_component_v_card, {
              variant: "flat",
              color: "grey-lighten-4",
              class: "mt-3 pa-2 d-flex align-center flex-wrap ga-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("mdi-cloud-upload-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[15] || (_cache[15] = _createTextVNode(" 保存中... ", -1))
                      ], 64))
                    : (_ctx.invalidCellCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("mdi-alert-circle-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.invalidCellCount) + "件が保存できません ", 1)
                        ]))
                      : (_ctx.saveFailed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("span", _hoisted_21, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("mdi-alert-circle-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[18] || (_cache[18] = _createTextVNode(" 保存に失敗しました ", -1))
                            ]),
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              variant: "text",
                              color: "primary",
                              onClick: _ctx.flush
                            }, {
                              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createTextVNode(" 再試行 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.lastSavedAt)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode("mdi-check-circle-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.lastSavedAt) + " に自動保存 ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_divider, {
                  vertical: "",
                  class: "mx-1"
                }),
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "grey-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn_toggle, {
                  modelValue: _ctx.zoom,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.zoom) = $event)),
                  density: "compact",
                  variant: "outlined",
                  divided: "",
                  mandatory: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoomSteps, (step) => {
                      return (_openBlock(), _createBlock(_component_v_btn, {
                        key: step,
                        value: step,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(step) + "% ", 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_spacer),
                (_ctx.detail.permissions.canEdit && _ctx.detail.plan.planType !== 'overall')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      size: "small",
                      variant: "outlined",
                      color: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.transferDialog = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode("mdi-arrow-down-bold-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[23] || (_cache[23] = _createTextVNode(" 上位計画から転記 ", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "outlined",
                  loading: _ctx.exporting,
                  onClick: _ctx.exportExcel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-microsoft-excel", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createTextVNode(" Excel出力 ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                (_ctx.detail.permissions.canDelete)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      size: "small",
                      variant: "outlined",
                      color: "error",
                      loading: _ctx.deleting,
                      onClick: _ctx.deletePlan
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode("mdi-delete-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[27] || (_cache[27] = _createTextVNode(" 削除 ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.permissions.canSubmit)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      size: "small",
                      color: "primary",
                      variant: "flat",
                      disabled: _ctx.processing,
                      onClick: _ctx.openSubmitDialog
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("mdi-send", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.plan.status === "returned" ? "再提出する" : "提出する"), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "8",
                  lg: "9"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_teaching_plan_grid, {
                      ref: "grid",
                      layout: _ctx.detail.layout,
                      values: _ctx.detail.values,
                      "resolved-references": _ctx.detail.resolvedReferences,
                      "unresolved-comment-counts": _ctx.detail.unresolvedCommentCounts,
                      "transfer-cells": _ctx.transferCells,
                      editable: _ctx.detail.permissions.canEdit,
                      "selected-item-key": _ctx.selectedItemKey,
                      zoom: _ctx.zoom,
                      onSelect: _ctx.selectCell,
                      onChange: _ctx.onCellChange,
                      onJumpSource: _ctx.openPlan,
                      onTransferCell: _ctx.transferSingleCell
                    }, null, 8, ["layout", "values", "resolved-references", "unresolved-comment-counts", "transfer-cells", "editable", "selected-item-key", "zoom", "onSelect", "onChange", "onJumpSource", "onTransferCell"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4",
                  lg: "3",
                  class: "tp-panel-col"
                }, {
                  default: _withCtx(() => [
                    (_ctx.nurseryId)
                      ? (_openBlock(), _createBlock(_component_teaching_plan_support_panel, {
                          key: 0,
                          "nursery-id": _ctx.nurseryId,
                          "plan-id": _ctx.planId,
                          "template-id": _ctx.detail.plan.templateId,
                          layout: _ctx.detail.layout,
                          "selected-item-key": _ctx.selectedItemKey,
                          comments: _ctx.comments,
                          editable: _ctx.detail.permissions.canEdit,
                          onInsertText: _ctx.insertText,
                          onJumpPlan: _ctx.openPlan,
                          onJumpItem: _ctx.jumpToItem,
                          onCommentsUpdated: _ctx.onCommentsUpdated
                        }, null, 8, ["nursery-id", "plan-id", "template-id", "layout", "selected-item-key", "comments", "editable", "onInsertText", "onJumpPlan", "onJumpItem", "onCommentsUpdated"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.submitDialog,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.submitDialog) = $event)),
              "max-width": "600px",
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode("提出の確認", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        (_ctx.missingRequiredCells.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_v_alert, {
                                type: "warning",
                                variant: "tonal",
                                density: "compact"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 必須項目が" + _toDisplayString(_ctx.missingRequiredCells.length) + "件未入力のため提出できません。 ", 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("ul", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missingRequiredCells, (cell) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: cell.itemKey
                                  }, [
                                    _createElementVNode("a", {
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.jumpToMissing(cell.itemKey)), ["prevent"])
                                    }, _toDisplayString(cell.name), 9, _hoisted_23)
                                  ]))
                                }), 128))
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.planLabel) + " を提出します。提出後は承認されるまで編集できません。 ", 1),
                              (_ctx.detail.workflow.assignedFirstApproverName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createTextVNode(" 承認者: " + _toDisplayString(_ctx.detail.workflow.assignedFirstApproverName) + " ", 1),
                                    (_ctx.detail.workflow.assignedFinalApproverName)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " → " + _toDisplayString(_ctx.detail.workflow.assignedFinalApproverName), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.unresolvedCommentTotal > 0)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 1,
                                    type: "info",
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 未解決のコメントが" + _toDisplayString(_ctx.unresolvedCommentTotal) + "件あります。 ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          disabled: _ctx.submitting,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitDialog = false))
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          loading: _ctx.submitting,
                          disabled: _ctx.missingRequiredCells.length > 0,
                          onClick: _ctx.submit
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode(" 提出する ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "disabled", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.returnDialog,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.returnDialog) = $event)),
              "max-width": "600px",
              persistent: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode("差戻しの確認", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-body-2 mb-3" }, " 差戻しの理由を入力してください。作成者に通知されます。 ", -1)),
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.returnReason,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.returnReason) = $event)),
                          rows: "4",
                          variant: "outlined",
                          density: "compact",
                          color: "primary",
                          counter: _ctx.commentBodyMaxLength,
                          placeholder: "修正してほしい点を具体的に記入してください"
                        }, null, 8, ["modelValue", "counter"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          disabled: _ctx.returning,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.returnDialog = false))
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          color: "error",
                          variant: "flat",
                          loading: _ctx.returning,
                          disabled: !_ctx.isValidReturnReason,
                          onClick: _ctx.returnPlan
                        }, {
                          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                            _createTextVNode(" 差戻す ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "disabled", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_teaching_plan_transfer_dialog, {
              modelValue: _ctx.transferDialog,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.transferDialog) = $event)),
              "plan-id": _ctx.planId,
              onTransferred: _ctx.onTransferred
            }, null, 8, ["modelValue", "plan-id", "onTransferred"])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, " 指導計画が見つかりませんでした。 "))
  ]))
}